import { render, staticRenderFns } from "./NutrientRequirementsTableRequirementValue.vue?vue&type=template&id=56c4c290&scoped=true&lang=html&"
import script from "./NutrientRequirementsTableRequirementValue.vue?vue&type=script&lang=js&"
export * from "./NutrientRequirementsTableRequirementValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c4c290",
  null
  
)

export default component.exports